import React, { ReactElement, useState } from 'react'
import {
  StyledCardTrainingGroup,
  Container,
  IconAbsolute,
  RelativeDiv,
} from '../../styled-components'

import AdminTemplate from '../../../base-template'
import Text from '../../../text'
import { TrainingGroup } from '../../../../types/training'
import Icon from '../../../icon'
import TrainingGroupsAddEdit from '../add-edit-training-group'

interface TrainingGroupsCardsProps {
  trainingsGroups: TrainingGroup[] | undefined
}

const TrainingGroups = ({
  trainingsGroups,
}: TrainingGroupsCardsProps): ReactElement => {
  const [editTrainingGroup, setEditTrainingGroup] = useState<
    TrainingGroup | undefined
  >(undefined)

  return (
    <AdminTemplate>
      {editTrainingGroup ? (
        <TrainingGroupsAddEdit
          trainingsGroup={editTrainingGroup}
          onClose={() => setEditTrainingGroup(undefined)}
        ></TrainingGroupsAddEdit>
      ) : (
        <Container>
          {trainingsGroups?.map((trainingsGroup) => (
            <RelativeDiv key={trainingsGroup.id}>
              <StyledCardTrainingGroup
                href={`/trainings?type=${trainingsGroup.name}`}
              >
                <Text> {trainingsGroup.title} </Text>
              </StyledCardTrainingGroup>
              <IconAbsolute
                onClick={() => setEditTrainingGroup(trainingsGroup)}
              >
                <Icon name="clarity:note-edit-line" width={25} height={25} />
              </IconAbsolute>
            </RelativeDiv>
          ))}
        </Container>
      )}
    </AdminTemplate>
  )
}
export default TrainingGroups
